export function getSignedClassName(amount) {
  if (amount >= 100) return `selected-100`;
  if (amount >= 50) return `selected-50`;
  if (amount >= 20) return `selected-20`;
  if (amount >= 5) return `selected-5`;
  return '';
}
